import * as React from 'react';
import './checkout.css';
// import Button from '../custom_components/button/button.component';
import { StoreState, CustomAction } from '../store';
import { Dispatch, bindActionCreators } from 'redux';
import { selectGeneric } from '../store/actions/generic.actions';
import { Signup_Obj } from '../store/reducers/signup_input.reducers';
import { connect } from 'react-redux';
// import { withRouter } from 'react-router';
import { Signup_Details_Obj } from '../store/reducers/signup_details.reducers';
import { Checkout_Obj, Checkout_Stage_Obj } from '../store/reducers/checkout_stage.reducers';
import Button from '../custom_components/button/button.component';

import { MailOption } from 'grommet-icons';

// import Button from '../custom_components/button/button.component';

export interface CheckoutE_Props {
    signup_form: Signup_Obj;
    signup_details: Signup_Details_Obj;
    checkout: Checkout_Obj;
    checkout_stage: Checkout_Stage_Obj;

    updateForm: Function;
    updateStage: Function;
}

export interface Country_Obj {
    name: string;
    short_name: string;
    code: string;
}

// const Device_Shipping = () => {

// }

class CheckoutE extends React.PureComponent<CheckoutE_Props> {

    render() {

        return (
            <div className="checkout-cta">
                <span className="checkout-cta-title">{this.props.checkout.title_text}</span>
                <div className="checkout-cta-text-box">
                    <span className="checkout-cta-sub-title">{this.props.checkout.sub_title_text}</span>
                </div>
                <div className="checkout-signup-form-c">
                    <MailOption size="xlarge" color="white"></MailOption>
                </div>
                <div className="checkout-nav-box">
                    <Button 
                        className="checkout-och-button"
                        onClick={this.nextStage} 
                        disabled={false}
                        text="Open OneClick HRM" 
                        color="#3463ef" 
                        text_color="white">
                    </Button>
                </div>
                <div className="checkout-cta-trial-text-box">
                    <span className="checkout-cta-trial-text">{this.props.checkout.comment_text}</span>
                </div>
            </div>
        )
    }

    nextStage = () => {
        window.location.href = 'https://home.oneclickhrm.com'
    }
}

export function mapStateToProps({ signup_form, signup_details, checkout_stage }: StoreState) {
    return {
      signup_form: signup_form,
      signup_details: signup_details,
      checkout_stage: checkout_stage
    }
}
  
export function mapDispatchToProps(dispatch: Dispatch<CustomAction>) {
    return bindActionCreators({
        updateForm: selectGeneric,
        updateStage: selectGeneric
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutE);


// WEBPACK FOOTER //
// ./src/checkout/checkout_e.component.tsx